<template>
  <div>
    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style ="background-color: transparent;">
        <v-card-title class="text-h5" v-if="Object.keys(this.position).length !== 0">{{getTranslated('_editLctPosition')}}</v-card-title>
        <v-card-title class="text-h5" v-else>{{getTranslated('_addLctPosition')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
            <v-text-field v-model="binordinal" :rules="requiredRule" type="number" :label="getTranslated('_binOrdinal')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="wmspositioncode" :rules="requiredRule" :label="getTranslated('_wmsPositionCode')" type="number" min="0" max="9">
              <template slot="append-outer">
                <v-tooltip bottom allow-overflow color="warning" transition="scale-transition" max-width="550">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="warning">mdi-alert-circle-outline</v-icon>
                  </template>
                  <span style="white-space: pre;">{{getTranslated('_fieldUsedInLocation')}}</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field v-model="wmspositionarea" :rules="requiredRule" :label="getTranslated('_wmsPositionArea')"></v-text-field>
            <v-text-field v-model="wmspositionzone" :rules="requiredRule" :label="getTranslated('_wmsPositionZone')"></v-text-field>
            <!-- <v-text-field v-model="wmspositionmaxuas" :rules="requiredRule" :label="getTranslated('_wmsPositionMaxUas')" type="number" min="0" max="99999"></v-text-field> -->
            <!-- <v-text-field v-model="wmslocationid" :rules="requiredRule" :label="getTranslated('_wmsLocationId')"></v-text-field> -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="save">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>
<script>
import lctPositionService from '../services/Lct_PositionsService.js'

export default {
  name: 'Lct_PositionEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    translations: Array,
    binId: String,
    wmsWarehouseId: String,
    position: Object
  },
  data () {
    return {
      title: '',
      valid: false,
      requiredRule: [v => !!v || this.getTranslated('_required')],
      dialogHeight: window.innerHeight,
      loading: false,
      binordinal: '',
      wmspositioncode: '',
      wmspositionarea: '',
      wmspositionzone: '',
      wmslocationid: '',
      id: ''
    }
  },
  watch: {
    isOpen () {
      if (this.isOpen && Object.keys(this.position).length !== 0) {
        this.binordinal = this.position.binOrdinal
        this.wmspositioncode = this.position.wmsPositionCode
        this.wmslocationid = this.position.wmsLocationId
        this.wmspositionarea = this.position.wmsPositionArea
        this.wmspositionzone = this.position.wmsPositionZone
        this.id = this.position.id
      }
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async save () {
      this.loading = true
      var positionToCreate = {
        binordinal: this.binordinal,
        wmspositioncode: this.wmspositioncode,
        wmslocationid: this.wmslocationid,
        wmsWarehouseId: this.wmsWarehouseId,
        wmsPositionArea: this.wmspositionarea,
        wmsPositionZone: this.wmspositionzone,
        binId: this.binId,
        id: this.id
      }
      if (Object.keys(this.position).length !== 0) {
        await lctPositionService.updateLct_Position(positionToCreate).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_LctPositionSaved')
                : this.getTranslated('_LctPositionSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      } else {
        await lctPositionService.createLct_Position(positionToCreate).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_LctPositionSaved')
                : this.getTranslated('_LctPositionSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      }
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.$refs.form.reset()
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
